import { render, staticRenderFns } from "./SalesCommissionSelect.vue?vue&type=template&id=4bc871c8"
import script from "./SalesCommissionSelect.vue?vue&type=script&lang=js"
export * from "./SalesCommissionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports